import React, { useContext, useEffect, useState } from "react";
import ProfileComplete from "../assets/profile_complete.png";
import Logo from "../assets/prairiwhite.png";
import Phone from "../assets/phone.png";
import MatchingIcon from "../assets/matching.png";
import { investorContext, authContext, navBarContext } from "./context/context";
import { useMediaQuery } from "react-responsive";
import { getDataFromUser, updateLatestActions } from "../utils";
import ConfettiExplosion from "react-confetti-explosion";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import axios from "axios";
import { PrairiButton, TextButton } from "@peterfosso/prairi-components";
import {
  collection,
  db,
  getDoc,
  doc,
  query,
  where,
  getDocs,
  updateDoc,
  Timestamp,
  addDoc,
} from "../firebase/firebaseApp";
import { getFunctions, httpsCallable } from "firebase/functions";

const ExpressMatching = () => {
  const [dataFetched, setDataFetched] = useState(false);
  const [userData, setUserData] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isExploding, setIsExploding] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { navBarHeight } = useContext(navBarContext);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const navigate = useNavigate();

  // Notification-related state
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [location, setLocation] = useState("us");
  const [active, setActive] = useState(false);
  const [notificationPreferences, setNotificationPreferences] = useState({
    email: true,
    sms: true,
    whatsapp: false,
  });
  const [preferencesSaved, setPreferencesSaved] = useState(false);
  const [showPreferences, setShowPreferences] = useState(true);
  const [preferencesError, setPreferencesError] = useState(false);

  const { currentUser } = useContext(authContext);


  const sendEmail = async (docId) => {
    const functions = getFunctions();
    const sendEmailFn = httpsCallable(functions, "sendEmail");
    try {
      const response = await sendEmailFn({
        templateId: 74,
        recipients: [
          {
            name: "Caro",
            email: "caro@prairi.com",
          },
        ],
        params: {
          URL: `https://www.prairi.com/newprofile/${docId}`,
          NAME: userData.contactName,
        },
      });
    } catch (error) {
      console.error("Error sending email", error);
    }
  };

  useEffect(() => {
    const checkApprovalAndSendEmail = async () => {
      if (!dataFetched) return;

      // If user already has approval status, do nothing
      if (userData.active || userData.pendingApproval) return;

      try {
        // Send email
        await sendEmail(userId);

        // Update user document with pendingApproval
        const userRef = doc(db, "users", userId);
        await updateDoc(userRef, { pendingApproval: true });

        // Update local state
        setUserData((prev) => ({ ...prev, pendingApproval: true }));
      } catch (error) {
        console.error("Error in approval process:", error);
      }
    };

    checkApprovalAndSendEmail();
  }, [dataFetched]);

  const sendLoginSMS = async (userData, userId) => {
    //Send ONLY ONCE. So we'll store that.
    try {
      const docRef = doc(db, "users", userId);
      await updateDoc(docRef, { loginSMS: true });
      const messagesCollection = collection(db, "messages");
      const dataToStore = {
        to: `+${phone}`,
        body: `Hi ${userData?.formData?.company?.contactName?.split(" ")[0] || "there"}!
You're all set! We'll text you when there's a startup match.
View your dashboard anytime: https://prairi.com`,
      };
      await addDoc(messagesCollection, dataToStore);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const checkVerificationAndSendEmail = async () => {
      if (!dataFetched) return;

      // If user already has approval status, do nothing
      if (userData.emailVerified) return;

      try {
        // Send email
        await sendEmailToUser(userId);
        await updateDoc(doc(db, "users", userId), { emailVerified: true });
      } catch (error) {
        console.error("Error in verification process:", error);
      }
    };

    checkVerificationAndSendEmail();
  }, [dataFetched]);

  const sendEmailToUser = async (docId) => {
    const functions = getFunctions();
    const sendEmailFn = httpsCallable(functions, "sendEmail");
    try {
      const response = await sendEmailFn({
        templateId: 75,
        recipients: [
          { name: userData.contactName, email: userData.email },
        ],
        params: {
          NAME: userData.contactName.split(" ")[0],
          URL: `https://www.prairi.com/verify/${docId}`,
          EMAIL: userData.email,
        },
      });
    } catch (error) {
      console.error("Error sending email", error);
    }
  };

  // Notification-related functions
  const handlePhoneChange = (value) => {
    setPhone(value);
    setPhoneError(false);
  };

  const handlePhoneBlur = () => {
    if (!phone || phone.length < 8) {
      setPhoneError(true);
    } else {
      setPhoneError(false);
    }
  };

  const handlePreferenceChange = (preference) => {
    setNotificationPreferences((prev) => ({
      ...prev,
      [preference]: !prev[preference],
    }));
    setPreferencesSaved(false);
    setPreferencesError(false);
  };

  const handlePreferencesSave = async () => {
    // Validate that at least email or sms is selected
    if (!notificationPreferences.email && !notificationPreferences.sms) {
      setPreferencesError(true);
      return;
    }
    try {
      const userRef = doc(db, "users", userId);
      const updateData = {
        notificationPreferences: notificationPreferences,
      };

      if (notificationPreferences.sms) {
        if (!phone || phone.length < 8) {
          setPhoneError(true);
          return;
        }
        updateData.phone = phone;
      }
      await updateDoc(userRef, updateData);
      updateLatestActions(
        userRef,
        "Updated notification preferences",
        isMobile
      );
      setPreferencesSaved(true);
      setPreferencesError(false);

      // Send SMS if SMS notifications are enabled and phone is provided
      if (
        notificationPreferences.sms &&
        phone &&
        phone.length >= 8 &&
        !userData.loginSMS
      ) {
        await sendLoginSMS(userData, userId);
      }

      // Start the timer to hide preferences
      setTimeout(() => {
        navigate("/dataprofile/investor")
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      // Verificar que currentUser existe antes de continuar
      if (!currentUser || !currentUser.uid) {
        setIsLoading(false);
        return;
      }
      
      try {
        const { userData, userId } = await getDataFromUser(currentUser.uid);
        setUserData(userData);
        setUserId(userId);
        setDataFetched(true);
        setIsExploding(!userData.explosion);
        if (userData && !userData.explosion) {
          const docRef = doc(db, "users", userId);
          await updateDoc(docRef, { explosion: true });
        }

        // Set notification preferences if they exist
        if (userData.notificationPreferences) {
          setNotificationPreferences(userData.notificationPreferences);
        }
        if (userData.active) {
          setActive(userData.active);
        }

        // Set phone numbers if they exist
        if (userData.phone) {
          setPhone(userData.phone);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [currentUser]);

  // Fetch location for phone input
  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await axios.get("https://ipapi.co/json/");
        setLocation(response.data.country_code.toLowerCase());
      } catch (error) {
        console.log(error);
      }
    };
    fetchLocation();
  }, []);

  // Hide preferences if they already exist
  useEffect(() => {
    if (userData && userData.notificationPreferences) {
      setShowPreferences(false);
    }
  }, [userData]);

  return (
    <div className="shadow-grey w-full h-full rounded-md mt-2 items-center justify-center flex flex-col mx-auto py-2.5 pb-[520px]"
    style={{
      paddingTop: navBarHeight,
    }}
      >
    {isLoading ? (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-greenPrairi mx-auto mb-4"></div>
          <p className="text-silverPrairi">Loading...</p>
        </div>
      </div>
    ) : !currentUser ? (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <p className="text-silverPrairi mb-4">Please log in to access this page.</p>
          <PrairiButton
            label="Go to Login"
            click={() => navigate("/login")}
            size="md"
            border="thinGreen"
            rounded="soft"
          />
        </div>
      </div>
    ) : (
      <>
    <div></div>
    <div className=" text-center  mt-5 ">
      <img
        className="h-24 mb-5 mx-auto items-center flex"
        src={MatchingIcon}
        alt="Matching"
      />
      <div className=" text-center text-2xl font-bold ">
        {"Sign-up is Complete!"}
      </div>
    </div>
    <div className="justify-center items-center flex">
      {dataFetched && userData && isExploding && (
        <ConfettiExplosion />
      )}
    </div>
    <div className="flex flex-col mt-7 items-center justify-center text-center text-md">
      <div className="w-full ">
        <p className="text-center">
        PRAIRI will now find you startups you'll love, based on your criteria.
        <br/>
        You'll be notified whenever there's a match.
          </p>
      </div>

      {(active || !showPreferences) && (
        <div className="flex flex-col justify-between w-full mt-4 items-center mx-auto">
          <PrairiButton
            label="View Profile"
            click={() => navigate("/dataprofile/investor")}
            size="md"
            border="thinGreen"
            rounded="soft"
          />
                      <TextButton
              label="Continue editing your profile"
              click={() => navigate("/investorregistration/company")}
              color="silver"
            />
        </div>
      )}
    </div>

    {!active && showPreferences && dataFetched && (
      <div className="mt-12 border-t border-gray-700 pt-8 w-full max-w-xl">
        <h2 className="uppercase text-center w-full text-xl mb-6">
          Notifications
        </h2>
        <p className=" mb-6">
          In addition to email, we recommend SMS so you can hear from startups more quickly:
        </p>
        <div className="flex flex-col space-y-4 px-4">

          <div className="flex flex-col">
            <FormControlLabel
              control={
                <Checkbox
                  checked={notificationPreferences.sms}
                  onChange={() => handlePreferenceChange("sms")}
                  name="sms"
                  style={{ color: "#92d050" }}
                />
              }
              label="SMS notifications"
              style={{ color: "white" }}
            />
            {notificationPreferences.sms && (
              <div className="ml-8 mt-2">
                <div className="flex items-center">
                  <PhoneInput
                    country={location}
                    value={phone}
                    onChange={handlePhoneChange}
                    onBlur={handlePhoneBlur}
                    inputProps={{
                      id: "phone",
                      required: true,
                      name: "phone",
                      autoComplete: "tel",
                    }}
                    countryCodeEditable={false}
                    enableLongNumbers={true}
                    preserveOrder={["onlyCountries", "preferredCountries"]}
                    inputStyle={{
                      color: "black",
                      width: "100%",
                      borderRadius: "0.25rem",
                      borderWidth: "1px",
                      fontSize: "1rem",
                      paddingTop: "0.625rem",
                      paddingBottom: "0.625rem",
                      paddingRight: "1rem",
                      outline: "none",
                    }}
                    dropdownStyle={{ color: "black" }}
                  />
                </div>
                {phoneError && (
                  <div className="text-sm text-red-500 mt-2">
                    Provide a valid phone number for SMS notifications
                  </div>
                )}
              </div>
            )}
          </div>
          {preferencesError && (
            <div className="text-sm text-red-500 mt-2">
              Please select at least Email or SMS notifications
            </div>
          )}
        </div>
        <div className="flex flex-col justify-center items-center mt-6">
          <button
            className="border border-greenPrairi border-[2px] text-white px-4 py-2 rounded-xl"
            onClick={handlePreferencesSave}
          >
            <span className="font-bold">Save Preferences</span>
            <br/>and View Your Profile
          </button>
          {preferencesSaved && (
            <p className="text-silverPrairi text-xs">Preferences saved!</p>
          )}
        </div>
      </div>
    )}

    {!active && !showPreferences && (
      <div className="flex items-center justify-center mt-4">
        <div className="text-center text-silverPrairi italic text-md mt-4 w-full">
          You can update your notification preferences anytime in your
          settings.
        </div>
      </div>
    )}
    </>
    )}
  </div>
);
};

export default ExpressMatching;
